import React from 'react';

const StuOnlineClass = () => {
    return (
        <div>
            Online Class
        </div>
    );
};

export default StuOnlineClass;